import React, { Component } from "react"
import Button from "@material-ui/core/Button"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import { Link } from "react-router-dom"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Redirect } from "react-router-dom"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"
import JDate from "jalali-date"
import Switch from "@material-ui/core/Switch"
import Snackbar from "@material-ui/core/Snackbar"
import * as constants from "../constants"
import Divider from "@material-ui/core/Divider"
import TableSortLabel from "@material-ui/core/TableSortLabel"
import Moment from "moment"
import NumberFormat from "react-number-format"
import HighlightOffIcon from "@material-ui/icons/HighlightOff"

import Collapse from "@material-ui/core/Collapse"
import Avatar from "@material-ui/core/Avatar"

import "react-modern-calendar-datepicker/lib/DatePicker.css"
import Calendar from "react-modern-calendar-datepicker"
import OutlinedInput from "@material-ui/core/OutlinedInput"
import IconButton from "@material-ui/core/IconButton"
import InputAdornment from "@material-ui/core/InputAdornment"
import FloatingLabelInput from "./FloatingLabelInput"
import Fab from "@material-ui/core/Fab"
import VoiceOverOffIcon from "@material-ui/icons/VoiceOverOff"
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver"
import CloseIcon from "@material-ui/icons/Close"
import CheckIcon from "@material-ui/icons/Check"
import Select from "react-select"

import ImageUploader from "react-images-upload"
import LinearProgress from "@material-ui/core/LinearProgress"

const styles = (theme) => ({
    paperrtl: {
        marginTop: theme.spacing(0),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    paper: {
        display: "flex",
        flexWrap: "wrap",
        "& > *": {
            margin: theme.spacing(1),
            width: theme.spacing(20),
        },
    },
    root: {
        width: "100%",
        margin: "15px",
        padding: "8px",
        direction: "rtl",
    },
    container: {
        maxHeight: 400,
    },
    large: {
        width: theme.spacing(10),
        height: theme.spacing(10),
    },
    small: {
        width: theme.spacing(6),
        height: theme.spacing(6),
    },
})

class ChangeAccidentSideCoverage extends Component {
    cookies = new Cookies()
    temp333
    constructor(props) {
        super(props)
        this.state = {
            redirect: false,
            errstr: "",
            errstatus: false,
            okstatus: false,
            requestinfos: [],
            agentInfofilter: [],
            rowsPerPage: 10,
            page: 0,
            accident_side_coverage_id: "",
            accident_side_coverage_name: "",
            accident_side_coverage_desc: "",
            accident_side_coverage_is_sport: "",

            orderBy: "accident_side_coverage_id",
            order: "desc",
            snackstr: "",
            showSnack: false,
            snackMode: "success",
            newAccidentSideCoverage: true,
        }
    }

    handleChangeAccidentSideCoverageName = (event) => {
        this.setState({ accident_side_coverage_name: event.target.value })
    }


    handleChangeAccidentSideCoverageDesc = (event) => {

        this.setState({ accident_side_coverage_desc: event.target.value })
    }
    handleChangeIsSport = (event) => {
        const isChecked = event.target.checked;

        const newStatus = isChecked ? "1" : "0";



        this.setState({ accident_side_coverage_is_sport: newStatus })

    }

    handleChangeAccidentSideCoverageId = (event) => {
        this.setState({ accident_side_coverage_id: event })
    }

    handleClickcloseTasckBar = (event) => {
        this.setState({ showSnack: false })
    }

    handleSelectRows = (row2) => {
        this.setState(
            {
                accident_side_coverage_id: row2.accident_side_coverage_id,
                accident_side_coverage_name: row2.accident_side_coverage_name,
                accident_side_coverage_desc: row2.accident_side_coverage_desc,
                accident_side_coverage_is_sport: row2.accident_side_coverage_is_sport,
                newAccidentSideCoverage: false,
            },
            () => {}
        )
    }

    newAccidentSideCoverage = (event) => {
        this.setState({
            accident_side_coverage_id: "",
            accident_side_coverage_name: "",
            accident_side_coverage_desc: "",
            newAccidentSideCoverage: true,
        })
    }
    componentDidMount() {
        if (this.cookies.get("employee_token_str")) {
            this.props.props.props.dispatch({
                type: "WAITSHOW",
            })

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                if (this.readyState === 4 && this.status === 200) {
                    var arr = JSON.parse(this.responseText)
                    if (arr.result === "ok") {
                        self.getAccidentSideCoverage()
                    } else if (arr.result === "error") {
                        self.setState({ redirect: true })
                    }
                    self.props.props.props.dispatch({
                        type: "WITEHIDE",
                    })
                }
            }
            var fd = new FormData()
            fd.append("command", "checkemployeelogin")

            xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
        } else {
            this.setState({ redirect: true })
        }
    }

    getAccidentSideCoverage() {
        this.props.props.props.dispatch({
            type: "WAITSHOW",
        })
        var self = this
        var xhttp = new XMLHttpRequest()
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText)
                console.log(arr)
                if (arr.result === "ok") {
                    self.setState({ requestinfos: arr.data, agentInfofilter: arr.data }, () => {})
                } else if (arr.result === "error") {
                }
                self.props.props.props.dispatch({
                    type: "WITEHIDE",
                })
            }
        }
        var fd = new FormData()
        fd.append("command", "get_accident_side_coverage")

        xhttp.open("POST", `${constants.BASE_URL}/Accident`)
        xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
        xhttp.send(fd)
    }

    saveNewAccidentSideCoverage = () => {
        const { accident_side_coverage_id, accident_side_coverage_name, accident_side_coverage_desc } = this.state
        if (accident_side_coverage_id != "" && accident_side_coverage_name != "") {
            this.props.props.props.dispatch({
                type: "WAITSHOW",
            })

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                if (this.readyState === 4 && this.status === 200) {
                    var arr = JSON.parse(this.responseText)
                    console.log(arr)
                    if (arr.result === "ok") {
                        self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        //self.setState({ redirect: true })
                        self.getAccidentSideCoverage()
                    } else if (arr.result === "error") {
                        self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                    }
                    self.props.props.props.dispatch({
                        type: "WITEHIDE",
                    })
                }
            }
            var fd = new FormData()
            fd.append("command", "add_accident_side_coverage")
            fd.append("accident_side_coverage_id", accident_side_coverage_id)
            fd.append("accident_side_coverage_name", accident_side_coverage_name)
            fd.append("accident_side_coverage_desc", accident_side_coverage_desc)

            xhttp.open("POST", `${constants.BASE_URL}/Accident`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
        } else {
            this.setState({ snackstr: "لطفا مشخصات پوشش فرعی حوادث  را وارد نمایید", showSnack: true, snackMode: "error" })
        }
    }

    deleteAccidentSideCoverage = () => {
        const { accident_side_coverage_id } = this.state

        this.props.props.props.dispatch({
            type: "WAITSHOW",
        })

        var self = this
        var xhttp = new XMLHttpRequest()
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText)
                console.log(arr)
                if (arr.result === "ok") {
                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                    self.newAccidentSideCoverage()
                    self.getAccidentSideCoverage()
                } else if (arr.result === "error") {
                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                }
                self.props.props.props.dispatch({
                    type: "WITEHIDE",
                })
            }
        }
        var fd = new FormData()
        fd.append("command", "delete_accident_side_coverage")
        fd.append("accident_side_coverage_id", accident_side_coverage_id)

        xhttp.open("POST", `${constants.BASE_URL}/Accident`)
        xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
        xhttp.send(fd)
    }

    changeAccidentSideCoverage = () => {
        const { accident_side_coverage_id, accident_side_coverage_name, accident_side_coverage_desc, accident_side_coverage_is_sport  } = this.state
        if (accident_side_coverage_id != "" && accident_side_coverage_name != "") {
            this.props.props.props.dispatch({
                type: "WAITSHOW",
            })

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                if (this.readyState === 4 && this.status === 200) {
                    var arr = JSON.parse(this.responseText)
                    console.log(arr)
                    if (arr.result === "ok") {
                        self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        //self.setState({ redirect: true })
                        self.getAccidentSideCoverage()
                    } else if (arr.result === "error") {
                        self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                    }
                    self.props.props.props.dispatch({
                        type: "WITEHIDE",
                    })
                }
            }
            var fd = new FormData()
            fd.append("command", "modify_accident_side_coverage")
            fd.append("accident_side_coverage_id", accident_side_coverage_id)
            fd.append("accident_side_coverage_name", accident_side_coverage_name)
            fd.append("accident_side_coverage_desc", accident_side_coverage_desc)
            fd.append("accident_side_coverage_is_sport", accident_side_coverage_is_sport)

            xhttp.open("POST", `${constants.BASE_URL}/Accident`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
        } else {
            this.setState({ snackstr: "لطفا مشخصات پوشش فرعی حوادث  را وارد نمایید", showSnack: true, snackMode: "error" })
        }
    }

    createSortHandler = (field) => {
        if (this.state.orderBy === field) {
            if (this.state.order === "asc") {
                this.setState({ order: "desc" })
            } else {
                this.setState({ order: "asc" })
            }
        } else {
            this.setState({ orderBy: field, order: "asc" })
        }
        var arraytemp = [],
            i,
            j,
            temp,
            a,
            b
        arraytemp = this.state.agentInfofilter
        for (i = 0; i < arraytemp.length; i++) {
            for (j = 0; j < arraytemp.length - 1; j++) {
                a = arraytemp[j]
                b = arraytemp[j + 1]
                if (a[field] < b[field] && this.state.order === "asc") {
                    temp = arraytemp[j]
                    arraytemp[j] = arraytemp[j + 1]
                    arraytemp[j + 1] = temp
                } else if (a[field] > b[field] && this.state.order === "desc") {
                    temp = arraytemp[j]
                    arraytemp[j] = arraytemp[j + 1]
                    arraytemp[j + 1] = temp
                }
            }
        }
    }



    handleChangeRowsPerPage = (event) => {
        this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 })
    }

    handleChangePage = (event, number) => {
        this.setState({ page: parseInt(number, 0) })
    }

    render() {
        const { classes } = this.props
        const {
            agentPermision,
            snackMode,
            snackstr,
            showSnack,
            newAccidentSideCoverage,
            accident_side_coverage_id,
            accident_side_coverage_name,
            accident_side_coverage_desc,
            accident_side_coverage_is_sport,
            order,
            orderBy,
            okstatus,
            errstr,
            redirect,
            agentInfofilter,
            rowsPerPage,
            page,
        } = this.state
        if (redirect) {
            return <Redirect to="/" />
        } else {
            return (
                <div className={classes.paperrtl} dir="ltr">
                    <Snackbar
                        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                        onClose={this.handleClickcloseTasckBar}
                        open={showSnack}
                        autoHideDuration={10000}
                    >
                        <Alert severity={snackMode}>{snackstr}</Alert>
                    </Snackbar>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <Container component="main" maxWidth="lg">
                                <Paper elevation={4} className={classes.root}>
                                    <Grid container spacing={3}>
                                        <Grid item xs={12}></Grid>

                                        <Grid item xs={6}>
                                            <Typography align="center" variant="h7">
                                                <FloatingLabelInput
                                                    type="number"
                                                    placeholder="آی دی پوشش فرعی حوادث "
                                                    handleInputt={this.handleChangeAccidentSideCoverageId}
                                                    value={accident_side_coverage_id}
                                                />
                                            </Typography>
                                        </Grid>


                                        <Grid item xs={6}>
                                            <FloatingLabelInput
                                                placeholder="پوشش فرعی حوادث "
                                                handleInputt={this.handleChangeAccidentSideCoverageName}
                                                value={accident_side_coverage_name}
                                            />
                                        </Grid>

                                        {console.log("test",accident_side_coverage_is_sport)}
                                        <Grid item xs={12}>
                                            <FloatingLabelInput
                                                placeholder="توضیحات"
                                                handleInputt={this.handleChangeAccidentSideCoverageDesc}
                                                value={accident_side_coverage_desc} // مقدار پیش‌فرض ۰
                                            />
                                        </Grid>

                                        <Grid item xs={2}>

                                            <FormControlLabel
                                                control={
                                                    <Switch
                                                        checked={accident_side_coverage_is_sport === "0" ? false : true}
                                                        onChange={this.handleChangeIsSport}
                                                        name="extrafinancial_status"
                                                    />
                                                }
                                                label="پوشش ورزشی"
                                            />
                                        </Grid>


                                        <Grid item xs={12}>
                                            <Divider />
                                        </Grid>

                                        <Grid item xs={12}>
                                            {newAccidentSideCoverage ? (
                                                <Button
                                                    variant="outlined"
                                                    color="primary"
                                                    onClick={(e) => {
                                                        this.saveNewAccidentSideCoverage()
                                                    }}
                                                >
                                                    {"ثبت پوشش فرعی حوادث  جدید "}
                                                </Button>
                                            ) : (
                                                <div style={{ width: "100%", textAlign: "right" }}>
                                                    <Button
                                                        variant="outlined"
                                                        color="primary"
                                                        onClick={this.newAccidentSideCoverage}
                                                    >
                                                        {"پوشش فرعی حوادث  جدید"}
                                                    </Button>
                                                    {"          "}
                                                    <Button
                                                        variant="outlined"
                                                        color="primary"
                                                        onClick={(e) => {
                                                            this.changeAccidentSideCoverage()
                                                        }}
                                                    >
                                                        {"ثبت تغییرات"}
                                                    </Button>
                                                    {"          "}
                                                    <Button
                                                        variant="outlined"
                                                        color="primary"
                                                        onClick={(e) => {
                                                            this.deleteAccidentSideCoverage()
                                                        }}
                                                    >
                                                        {"حذف"}
                                                    </Button>
                                                </div>
                                            )}
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Container>
                        </Grid>
                        <Grid item xs={12}>
                            <Container maxWidth="lg">
                                <Paper className={classes.root}>
                                    <TableContainer dir="rtl">
                                        <Table aria-label="sticky table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell
                                                        key={"accident_side_coverage_id"}
                                                        align={"center"}
                                                        style={{ minWidth: 20 }}
                                                        sortDirection={orderBy === "accident_side_coverage_id" ? order : false}
                                                    >
                                                        {"آیدی پوشش فرعی حوادث  "}
                                                        <TableSortLabel
                                                            active={orderBy === "accident_side_coverage_id"}
                                                            direction={
                                                                orderBy === "accident_side_coverage_id" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("accident_side_coverage_id")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>

                                                    <TableCell
                                                        key={"accident_side_coverage_name"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"پوشش فرعی حوادث  "}
                                                        <TableSortLabel
                                                            active={orderBy === "accident_side_coverage_name"}
                                                            direction={
                                                                orderBy === "accident_side_coverage_name" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("accident_side_coverage_name")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>



                                                    <TableCell
                                                        key={"accident_side_coverage_desc"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"توضیحات پوشش فرعی حوادث  "}
                                                        <TableSortLabel
                                                            active={orderBy === "accident_side_coverage_desc"}
                                                            direction={
                                                                orderBy === "accident_side_coverage_desc" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("accident_side_coverage_desc")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>


                                                </TableRow>
                                            </TableHead>

                                            <TableBody>
                                                {agentInfofilter
                                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                    .map((row) => {
                                                        return (
                                                            <TableRow
                                                                hover
                                                                role="checkbox"
                                                                tabIndex={-1}
                                                                key={row["accident_side_coverage_id"]}
                                                                value={row}
                                                                onClick={() => {
                                                                    this.handleSelectRows(row)
                                                                }}
                                                            >
                                                                <TableCell
                                                                    key={"accident_side_coverage_id"}
                                                                    align={"center"}
                                                                >
                                                                    {row["accident_side_coverage_id"]}
                                                                </TableCell>

                                                                <TableCell
                                                                    key={"accident_side_coverage_name"}
                                                                    align={"center"}
                                                                >
                                                                    {row["accident_side_coverage_name"]}
                                                                </TableCell>

                                                                <TableCell
                                                                    key={"accident_side_coverage_desc"}
                                                                    align={"center"}
                                                                >
                                                                    {row["accident_side_coverage_desc"]}
                                                                </TableCell>
                                                            </TableRow>
                                                        )
                                                    })}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                    <TablePagination
                                        rowsPerPageOptions={[10, 25, 100]}
                                        component="div"
                                        count={agentInfofilter.length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onChangePage={this.handleChangePage}
                                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                    />
                                </Paper>
                            </Container>
                        </Grid>
                    </Grid>

                    {okstatus ? (
                        <Alert severity="success">
                            <AlertTitle>پیام</AlertTitle>
                            {errstr}
                        </Alert>
                    ) : null}
                </div>
            )
        }
    }
}

export default withStyles(styles)(ChangeAccidentSideCoverage)
